<template>
  <router-view v-slot="{ Component }">
    <suspense>
      <component
        :is="Component"
      />
      <template #fallback>
        <splash />
      </template>
    </suspense>
  </router-view>
</template>

<script>

export default {
  name: 'FulfillmentSettingsRoot',
};

</script>
